<template>
  <ExpeditionTable />
</template>

<script>
import ExpeditionTable from '../../../../../components/expedition/ExpeditionTable.vue';

export default {
  components: { ExpeditionTable }
}
</script>